export interface IAttachment {
  name: string;
  type?: string;
  base64?: string | ArrayBuffer;
  size: number;
  value?: AttachmentSubmit;
  date?: string;
  url?: string;
  mime_type?: string;
  source: EDownloadSourceType;
  transactionId?: string;
  uuid?: string;
}

export enum EDownloadSourceType {
  MS_STORAGE = 'MS_STORAGE',
  MS_DYNAMIC_FORMS = 'MS_DYNAMIC_FORMS',
}

export interface AttachmentSubmit {
  uuid: string;
  name: string;
}

export interface FileToUpload {
  project: string;
  user_uuid: string;
  type: string;
  name: string;
  mime_type: string;
  size: number;
  content: string;
}
